import { render } from "./adultEtc.vue?vue&type=template&id=49ab4696&scoped=true"
import script from "./adultEtc.vue?vue&type=script&lang=js"
export * from "./adultEtc.vue?vue&type=script&lang=js"

import "./adultEtc.vue?vue&type=style&index=0&id=49ab4696&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ab4696"]])

export default __exports__